module.exports = __webpack_public_path__ + "static/img/zhuyeqing.c7673dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/zhuyeqing.jpg
// module id = M7CJ
// module chunks = 0